<!-- MULTISELECCIÓN CON SUBOPCIONES -->
@if (hasSubOptions) {
  <p-listbox
    [options]="flattenedOptions"
    [(ngModel)]="selectedOption"
    (ngModelChange)="onModelChange($event)"
    [multiple]="true"
    [checkbox]="true"
    optionLabel="nombre"
    [class]="'custom-listbox'"
  >

  </p-listbox>
}

<!-- UNA SOLA CASILLA SI NO HAY SUBOPCIONES -->
<!-- !Revisar estilos en input -> [ngClass] -->
@if (!hasSubOptions) {
  <div
    class="flex items-center space-x-2 p-3 pl-6 hover:bg-gray-100"
    [ngClass]="{
      'bg-blue-50 hover:bg-blue-50': selectedOption?.id === idCategoria,
    }"
  >
    <input
      type="checkbox"
      [checked]="selectedOption?.id == idCategoria"
      (change)="onSingleCheckboxChange($event)"
      [id]="'checkbox-' + idCategoria"
      class="accent-primary-900 w-5 h-5 cursor-pointer"
    />
    <label
      [for]="'checkbox-' + idCategoria"
      class="text-gray-500 cursor-pointer"
      [ngClass]="{
        'text-blue-700 bg-blue-200': selectedOption?.id === idCategoria,
      }"
    >
      {{ nombreCategoria }}
    </label>
  </div>
}
